import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { ResponseMFA } from 'src/app/modules/two-factor/verification-code/models/two-factor-models';
import { FormPasswordComponent } from 'src/app/standalone-components/form-password/form-password.component';
import { SecurityFormGroupType } from '../../models/form-types';

@Component({
    selector: 'app-security-step',
    templateUrl: './security-step.component.html',
    styleUrl: './security-step.component.scss',
    standalone: false,
})
export class SecurityStepComponent implements OnInit {
    @Input() email: string | null;
    @Input() dynamicResponse: ResponseMFA;
    @Output() submitEvent: EventEmitter<boolean> = new EventEmitter();
    @ViewChild('formPassword') formPasswordComponent: FormPasswordComponent;
    public parentForm: SecurityFormGroupType;

    constructor(private controlContainer: ControlContainer) {}

    ngOnInit(): void {
        this.parentForm = this.controlContainer.control as SecurityFormGroupType;
    }

    completeProcess(): void {
        this.submitEvent.emit(true);
    }

    onSetPassword(password: string): void {
        this.parentForm.controls['password'].setValue(password);
    }
}
